import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActionSheetController } from '@ionic/angular';
import { Designation } from 'src/app/models/Designation';
import { AuthService } from 'src/app/services/auth.service';
import { DesignationService } from 'src/app/services/modelService/designation.service';
import { EmployeeSService } from 'src/app/services/modelService/employeeS.service';
import { ParamService } from 'src/app/services/param.service';
import { AlertService } from 'src/app/util/alert.service';

@Component({
  selector: 'app-designation-location',
  templateUrl: './designation-location.component.html',
  styleUrls: ['./designation-location.component.scss'],
})
export class DesignationLocationComponent implements OnInit {
  displayEmployee;
  displayProfile: boolean = false;
  childList: any[] = [];
  locationTypeIndex: number;
  @Input() locationType: string;
  @Input() locationName: string;
  @Input() parent: any;
  @Input() arrowUp: boolean = false;
  @Input() countObject: any = {};
  dsList: Designation[] = [];

  constructor(public router: Router, public ds: DesignationService, public auth: AuthService,
    private empService: EmployeeSService, private actionSheetController: ActionSheetController,
    private paramService: ParamService, private alert: AlertService) { }

  ngOnInit() {
    this.locationTypeIndex = this.ds.locationTypeList.indexOf(this.locationType);
    this.getDsList();
  }


  getChildList() {
    this.arrowUp = true;
    this.childList = [];
    let child = this.ds.locationTypeList[this.locationTypeIndex + 1];
    this.getDsList();

    if (child) {
      this.ds.getCount(this.locationType, this.locationName, child).then((res: any) => {
        for (let item of res) {
          this.childList.push({
            name: item.group_value,
            type: child,
            countObject: item
          });
        }
      })
    }
  }

  getDsList() {
    this.ds.getList([['location_type', this.locationType], ['location_name', this.locationName], ['business_id', this.auth.loggedInEmployee.business_id]]).then((dsList: Designation[]) => {
      // console.log('dsList', dsList);
      this.dsList = dsList;
    })
  }



  onClickAddNew(designationId) {
    this.router.navigate(['designation-edit/' + this.locationName + '/' + this.locationType + '/' + this.parent + '/' + designationId]);
  }

  clickPost(designation: Designation) {
    this.empService.getEmpByVariable('id', designation.emp_id).then(async (emp: any) => {
      let buttonList = [];
      if (this.auth.loggedInEmployee.designation && this.auth.loggedInEmployee.designation.includes('admin')) {
        buttonList.push({
          text: 'Edit',
          icon: 'pencil',
          handler: () => {
            this.router.navigate(['designation-edit/' + this.locationName + '/' + this.locationType + '/' + this.parent + '/' + designation.id]);
          }
        });
      }
      buttonList.push({
        text: 'View Details',
        icon: 'eye',
        handler: () => {
          this.displayEmployee = emp;
          this.displayProfile = true;
        }
      });

      buttonList.push({
        text: 'View Vansh',
        icon: 'snow',
        handler: () => {
          this.paramService.setData("empFromList", emp)
          this.router.navigate(['/vansh/family-tree'], { replaceUrl: true });
        }
      });

      if (this.auth.loggedInEmployee.designation && this.auth.loggedInEmployee.designation.includes('admin')) {
        buttonList.push({
          text: 'Delete',
          icon: 'trash',
          handler: () => {
            this.alert.showAlert(
              'Remove ' + designation.emp_json.name,
              'Are you sure you want to remove this designation of ' + designation.emp_json.name + ' as ' + designation.name + ' from ' + designation.location_name + ' ?',
              'Delete'
            ).then(async () => {
              this.ds.deleteDesignation(designation.id).then(() => {
                emp.assigned_area = emp.assigned_area.filter(area => area !== designation.location_name);
                this.empService.saveObject(emp, false)
                this.dsList = this.dsList.filter((item) => {
                  return item.id !== designation.id;
                });
              })
            })
          }
        });
      }

      buttonList.push({
        text: 'Cancel',
        icon: 'close',
        handler: () => {
          console.log('Cancel clicked');
        }
      });

      const actionSheet = await this.actionSheetController.create({
        header: 'Member options : ' + emp.user.name,
        buttons: buttonList
      });

      await actionSheet.present();
    })
  }


  clickDashboardNumber(filterList) {
    // let filterList = [['user.user_pd.' + this.hierarchy.type, this.hierarchy.name]];
    this.paramService.setData('filterList', filterList);
    this.router.navigate(['/user-list']);
  }

}
